function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#945DD6",
  fillRule: "evenodd",
  d: "M17.706 5.708a1 1 0 000-1.415l-3.999-4a.999.999 0 10-1.414 1.414L14.586 4H1a1 1 0 100 2h13.586l-2.293 2.293a.999.999 0 101.414 1.414l3.999-3.999z"
});

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 10,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDE4IDEwIj4KICAgIDxwYXRoIGZpbGw9IiM5NDVERDYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjcwNiA1LjcwOGExIDEgMCAwIDAgMC0xLjQxNWwtMy45OTktNGEuOTk5Ljk5OSAwIDEgMC0xLjQxNCAxLjQxNEwxNC41ODYgNEgxYTEgMSAwIDEgMCAwIDJoMTMuNTg2bC0yLjI5MyAyLjI5M2EuOTk5Ljk5OSAwIDEgMCAxLjQxNCAxLjQxNGwzLjk5OS0zLjk5OXoiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };